import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 d-flex align-items-center justify-content-center" }
const _hoisted_2 = { class: "card h-25 shadow" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, null, -1)
const _hoisted_6 = { class: "position-absolute bottom-0 mb-3" }

import { useRouter } from 'vue-router';
import { translation } from '../../lang/Translation';
import { SessionMemory } from '../../utils/SessionMemory';
import { restCallApi } from '../../../framework/frontend/restCallApi';
import { SessionUser } from '../../utils/SessionUser';
import { Session } from '../../../framework/frontend/Session';

export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessPage',
  setup(__props) {

const t = translation;
const router = useRouter();

const back = async () => {
  const backPath = SessionMemory.instance.paymentBackPage;
  const token = Session.getJwtToken();
  // stripe系のAPIは、Serviceのフレームワークを使っていない
  const response = await restCallApi("post", "/get_new_auth", {user_id : SessionUser.instance.userId }, token )
  const user = Session.getSessionUser()
  user.authTag = response.data;
  SessionUser.instance.setNewAuthTagInSession(  user.authTag);
  router.push(backPath)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t).to("料金プランの変更が完了しました", "plan_change_done" )), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: back,
            class: "btn btn-primary btn-lg"
          }, _toDisplayString(_unref(t).to("戻る","back")), 1)
        ])
      ])
    ])
  ]))
}
}

})